export const extractSweepIdFromURL = (urlString) => {
  const startIndex = urlString.indexOf('s=') + 2;
  const endIndex = urlString.indexOf('&', startIndex);

  if (startIndex >= 2 && endIndex !== -1) {
    return urlString.substring(startIndex, endIndex);
  }

  return null;
};
